/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonAddressPortfolioListRequest = {
    page?: number;
    size?: number;
    address: string;
    tokenTypeList?: Array<'CW20' | 'IBC' | 'NATIVE'>;
    sortField?: BabylonAddressPortfolioListRequest.sortField;
    sortDirection?: BabylonAddressPortfolioListRequest.sortDirection;
};

export namespace BabylonAddressPortfolioListRequest {

    export enum sortField {
        VALUE = 'VALUE',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

